import { useAppData } from '../contexts/AppDataContext';
import { SUPPLIER_TIER_KEYS } from '../utils/supplierTierCounts';

const EMPTY_COUNTS = { 1: 0, 2: 0, 3: 0 };

export function useSupplierTierCounts() {
  const { supplierTierCounts, userCompaniesLoaded, loading: appLoading } = useAppData();

  return {
    tierCounts: supplierTierCounts ?? EMPTY_COUNTS,
    visibleTiers: SUPPLIER_TIER_KEYS,
    loading: appLoading && !userCompaniesLoaded,
  };
}
